import * as React from 'react';
import { Avatar } from '@mui/material';

interface HeaderProfileImageProps {
  userEmail: string;
  userProfilePicture: string | null;
}

const HeaderProfileImage: React.FC<HeaderProfileImageProps> = ({
  userProfilePicture,
  userEmail,
}) => {
  const userAvatar = {
    src: userProfilePicture || '',
    name: userEmail, // Only use user.name if authenticated
  };
  return (
    <Avatar
      sizes="large"
      alt={userAvatar.name}
      src={userAvatar.src}
      sx={{ border: '1px solid #FBE34E' }}
    />
  );
};

export default HeaderProfileImage;
